export default __webpack_public_path__ + "static/media/mob-app.d26c3a92.png";